import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from "@mui/material/Divider";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { cardStyle } from "../../../Dashboard/customStyles";
import { generateLBODashboard, updateLBODashboard } from "../../../../store/modules/dealOffer/actions";
import { generateAssumptions, updateAssumptions } from "../../../../store/modules/waterfall/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { primary } from "../../../../assets/colorPallet";
import Item from "../InputItem";

function LBODashboard({
  dealType,
  setSelectedDealType,
  currentLBODashboard,
  dispatchGenerateLBODashboard,
  dispatchUpdateLBODashboard,
  dispatchGenerateAssumptions,
  dispatchUpdateAssumptions
}) {
  // Mounted
  useEffect(() => {
    //dispatchGenerateLBODashboard(dealType);     //included
    dispatchGenerateAssumptions(dealType);
  }, []);

  const handleChange = (name, value) => {
    if(value === "STOCK" || value === "ASSET") setSelectedDealType(value);  //modify DealType when sharePriceType changes
    dispatchUpdateLBODashboard(name, value);
    if(name === "reinvestmentRate") dispatchUpdateAssumptions("reinvestRate", value, "Common", 0);   //link to waterfall settings
  };

  return (
    <div className="flex flex-wrap justify-center" style={{ minWidth: 610 }}>
      {currentLBODashboard &&
        (<>
          <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Switches / Assumptions"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item
                name="Minimum Cash Balance"
                data={currentLBODashboard.minimumCashBalance}
                handleChange={(value) => handleChange("minimumCashBalance", value)}
              />
              <Item
                name="Tax Rate"
                data={currentLBODashboard.taxRate}
                endLabel="%"
                handleChange={(value) => handleChange("taxRate", value)}
              />
              <div className="flex justify-between items-center my-3 px-5">
                <div className="flex items-center">
                  <div className="items-center text-lg mr-4">Transaction Costs at Close</div>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 130 }}>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={currentLBODashboard.transactionCostType}
                      onChange={(e) => handleChange("transactionCostType", e.target.value)}
                    >
                      <MenuItem value={"AUTO"}>Automatic</MenuItem>
                      <MenuItem value={"MANUAL"}>Manual Input</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <BVAInput
                  size="small"
                  width="170px"
                  textAlign="start"
                  disabled={currentLBODashboard.transactionCostType === "MANUAL" ? false : true}
                  endAdornment
                  endAdornmentLabel="$"
                  value={currentLBODashboard.transactionCosts}
                  onChange={(value) => handleChange("transactionCosts", value)}
                />
              </div>
              <Item
                name="Restructuring Charges"
                data={currentLBODashboard.restructuringCharges}
                handleChange={(value) => handleChange("restructuringCharges", value)}
              />
            </CardContent>
          </Card>

          <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Purchase Price"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <div className="flex justify-between items-center my-3 px-5">
                <div className="flex items-center">
                  <div className="items-center text-lg mr-4">Target Fair Share Price</div>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 150 }}>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={currentLBODashboard.sharePriceType}
                      onChange={(e) => handleChange("sharePriceType", e.target.value)}
                    >
                      <MenuItem value={"STOCK"}>Stock Purchase</MenuItem>
                      <MenuItem value={"ASSET"}>Asset Purchase</MenuItem>
                      <MenuItem value={"MARKETVALUE"}>Fair Market Value</MenuItem>
                      <MenuItem value={"MANUAL"}>Manual Input</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <BVAInput
                  size="small"
                  width="170px"
                  textAlign="start"
                  disabled={currentLBODashboard.sharePriceType === "MANUAL" ? false : true}
                  endAdornment
                  endAdornmentLabel="$"
                  value={currentLBODashboard.targetSharePrice}
                  onChange={(value) => handleChange("manualSharePrice", value)}
                />
              </div>
              <Item
                name="Premium or Discount"
                data={currentLBODashboard.premiumOrDiscount}
                endLabel="%"
                handleChange={(value) => handleChange("premiumOrDiscount", value)}
              />
              <Divider />
              <Item
                name="Offer Price per Share"
                data={currentLBODashboard.offerPricePerShare}
                disabled={true}
                bold={true}
              />
              <div style={{ height: 30 }} />
              <Item
                name="Target Co FD Shares Outstanding"
                data={currentLBODashboard.targetSharesOutstanding}
                endLabel="Shares"
                handleChange={(value) => handleChange("targetSharesOutstanding", value)}
              />
              <Item name="(×) Offer Price per Share" data={currentLBODashboard.offerPricePerShare} disabled={true} />
              <Divider />
              <Item name="Purchase Price" data={currentLBODashboard.purchasePrice} disabled={true} bold={true} />
              <Item name="(-) Debt Assumed" data={currentLBODashboard.debtAssumed} disabled={true} />
              <Divider />
              <Item name="Balance of Equity Owed" data={currentLBODashboard.balanceOfEquity} disabled={true} bold={true} />
            </CardContent>
          </Card>
          
          <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary }}    //primary is also good
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
              title="Earnout & Consulting"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <div className="flex text-center justify-between items-center my-3 px-5">
                <div className="items-center text-lg">Earnout Target</div>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 155 }}>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={currentLBODashboard.earnoutTarget}
                    onChange={(e) => handleChange("earnoutTarget", e.target.value)}
                  >
                    <MenuItem value={"Revenue"}>Revenue</MenuItem>
                    <MenuItem value={"EBITDA"}>EBITDA</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <Item
                name="Earnout Target Amount"
                data={currentLBODashboard.earnoutTargetAmount}
                handleChange={(value) => handleChange("earnoutTargetAmount", value)}
              />
              <Item
                name="Number of Earnout Years"
                data={currentLBODashboard.earnoutYears}
                endLabel="Years"
                handleChange={(value) => handleChange("earnoutYears", value)}
              />
              <Item
                name="Compensation (Annual)"
                data={currentLBODashboard.compensation}
                handleChange={(value) => handleChange("compensation", value)}
              />
              <Divider />
              <Item
                name="Earnout Target Total"
                data={currentLBODashboard.earnoutTargetTotal}
                disabled={true}
                bold={true}
              />
              <div style={{ height: 30 }} />
              <Item
                name="Consulting Fee (Monthly)"
                data={currentLBODashboard.consultingFee}
                handleChange={(value) => handleChange("consultingFee", value)}
              />
              <Item
                name="Consulting Period in Months"
                data={currentLBODashboard.consultingPeriod}
                endLabel="Months"
                handleChange={(value) => handleChange("consultingPeriod", value)}
              />
              <Divider />
              <Item
                name="Consulting Payment Totals"
                data={currentLBODashboard.consultingPaymentTotal}
                disabled={true}
                bold={true}
              />
            </CardContent>
          </Card>

          <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary }}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Balloon Payment"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item name="Interest Rate" data={currentLBODashboard.interestRate} endLabel="%" disabled={true} />
              <Item name="Amortized over" data={currentLBODashboard.amortizedOver} endLabel="Months" disabled={true} />
              <Item
                name="Grace Period"
                data={currentLBODashboard.gracePeriod}
                endLabel="Months"
                handleChange={(value) => handleChange("gracePeriod", value)}
              />
              <Item
                name="Balloon Payment after"
                data={currentLBODashboard.balloonPaymentAfter}
                endLabel="Months"
                handleChange={(value) => handleChange("balloonPaymentAfter", value)}
              />
              <Item
                name="Cash Sweep Portion"
                data={currentLBODashboard.cashSweepPortion}
                endLabel="%"
                handleChange={(value) => handleChange("cashSweepPortion", value)}
              />
            </CardContent>
          </Card>

          <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Assumptions for Investor DCF"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item
                name="Exit Year"
                data={currentLBODashboard.exitYear}
                endLabel="Years"
                handleChange={(value) => handleChange("exitYear", value)}
              />
              <Item
                name="Long Term Growth Rate"
                data={currentLBODashboard.longTermGrowthRate}
                endLabel="%"
                handleChange={(value) => handleChange("longTermGrowthRate", value)}
              />
              <Item
                name="Fixed Synergies & Growth Rate"
                data={currentLBODashboard.fixedSynergiesRate}
                endLabel="%"
                handleChange={(value) => handleChange("fixedSynergiesRate", value)}
              />
              <Item
                name="Dividends Payment Percentage"
                data={currentLBODashboard.dividendsPercent}
                endLabel="%"
                handleChange={(value) => handleChange("dividendsPercent", value)}
              />
              <Item
                id="LOC"
                name="Line of Credit Maximum Limit"
                data={currentLBODashboard.capacity}
                handleChange={(value) => handleChange("capacity", value)}
              />
              <Item
                name="SOFR Current"
                data={currentLBODashboard.SOFRCurrent}
                endLabel="bps"
                handleChange={(value) => handleChange("SOFRCurrent", value)}
              />
              <Item
                name="SOFR Step"
                data={currentLBODashboard.SOFRStep}
                endLabel="bps"
                handleChange={(value) => handleChange("SOFRStep", value)}
              />
              <Item
                name="PIK Step"
                data={currentLBODashboard.PIKStep}
                endLabel="bps"
                handleChange={(value) => handleChange("PIKStep", value)}
              />
              <Item
                name="Reinvestment Rate for MIRR"
                data={currentLBODashboard.reinvestmentRate}
                endLabel="%"
                handleChange={(value) => handleChange("reinvestmentRate", value)}
              />
            </CardContent>
          </Card>

          {/* <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Equity Acquisition Cost Assumptions"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item name="Risk Free Rate" data={currentLBODashboard.riskFreeRate} endLabel="%" disabled={true} />
              <Item name="Equity Risk Premium" data={currentLBODashboard.equityRiskPremium} endLabel="%" disabled={true} />
              <Item name="Size Premium" data={currentLBODashboard.sizePremium} endLabel="%" disabled={true} />
              <Item name="Industry Premium" data={currentLBODashboard.industryPremium} endLabel="%" disabled={true} />
              <Item name="Country Risk Premium" data={currentLBODashboard.countryRiskPremium} endLabel="%" disabled={true} />
              <Item name="Company Specific Risk Premium" data={currentLBODashboard.companyRiskPremium} endLabel="%" disabled={true} />
              <Divider />
              <Item name="Build Up Method" data={currentLBODashboard.buildUpMethod} endLabel="%" disabled={true} bold={true} />
            </CardContent>
          </Card> */}
        </>)
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentLBODashboard: state.dealOffer.currentLBODashboard,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateLBODashboard(dealType) {
    await dispatch(generateLBODashboard(dealType));
  },
  async dispatchUpdateLBODashboard(name, value) {
    await dispatch(updateLBODashboard(name, value));
  },
  async dispatchGenerateAssumptions(dealType) {
    await dispatch(generateAssumptions(dealType));
  },
  async dispatchUpdateAssumptions(name, value, type, index) {
    await dispatch(updateAssumptions(name, value, type, index));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LBODashboard);
